@if (company) {
  <div
    @enterFadeIn
    class="rounded-lg border border-gray-200 bg-neutral-98 p-5 shadow-sm">
    <div class="mb-6 flex items-start justify-between">
      <span class="text-lg font-medium text-primary-60">
        {{ company?.name }}
      </span>
      <a
        class="qaroni-link-on-surface flex items-center"
        *qaroniRoleAccessPermission
        [routerLink]="goToUpdateCompany"
        i18n
        >Editar</a
      >
    </div>
    <div class="flex flex-col gap-6 sm:flex-row">
      <div class="flex-shrink-0">
        <div
          class="flex h-24 w-24 items-center justify-center rounded-lg border border-gray-100 bg-white">
          <mat-icon
            fontIcon="qr_code_scanner"
            class="material-symbols-outlined h-fit w-fit text-5xl text-teal-600" />
        </div>
      </div>
      <div
        class="grid flex-1 grid-cols-1 gap-x-8 gap-y-4 text-sm md:grid-cols-2">
        <div class="sm:col-span-2 xl:col-span-1">
          <span class="company-information-title">Dirección</span>
          <qaroni-address-string
            [address]="company?.address"
            [showTitle]="false" />
        </div>
        <div>
          <span class="company-information-title">Teléfono</span>
          <a
            class="qaroni-link-on-surface company-information-value"
            [href]="getPhoneLink(company?.phone)"
            >{{ company?.phone ?? '-' }}</a
          >
        </div>
        <div class="sm:col-span-2 xl:col-span-1">
          <span class="company-information-title">Correo electrónico</span>
          <a
            class="qaroni-link-on-surface company-information-value"
            [href]="getMailLink(company?.email)"
            >{{ company?.email ?? '-' }}</a
          >
        </div>
        <div class="sm:col-span-2 xl:col-span-1">
          <span class="company-information-title">Fecha de alta</span>
          <div class="company-information-value">
            {{ (company?.creationDate | date: 'medium') ?? '-' }}
          </div>
        </div>
        <div class="sm:col-span-2">
          <span class="company-information-title">Última actualización</span>
          <span class="company-information-value">
            {{ (company?.lastUpdateDate | date: 'medium') ?? '-' }}</span
          >
        </div>
      </div>
    </div>
  </div>
}
